import { render, staticRenderFns } from "./Uncharted.vue?vue&type=template&id=59bb53fd&"
import script from "./Uncharted.vue?vue&type=script&lang=js&"
export * from "./Uncharted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports